import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@material-ui/core';

import uniqid from 'uniqid'
import { Visibility } from '@material-ui/icons';
import './ExperienceContainer.css'
import StackIcon from 'tech-stack-icons';

const ExperienceContainer = ({ experience }) => {

  const [open, setOpen] = useState(false);

  // Open the modal
  const handleOpen = () => {
    setOpen(true);
  };

  // Close the modal
  const handleClose = () => {
    setOpen(false);
  };
  console.log(experience)

  return (
    <div className='experience'>
      {console.log(experience, `${experience.icon}`)}
      <img
        // src={`../..${experience.icon}.jpg`} // Correctly use template literals
        src={experience.icon} // Use the icon path directly from the experiences array
        style={{
          objectFit: 'cover',
          left: 0,
          right: 0,
          top: '7rem',
          marginLeft: 'auto',
          marginRight: 'auto',
          width: '6rem',
          height: '6rem',
          borderRadius: '50%',
        }}
        className="shadow mb-3"
        alt=""
      />


      <h4>{experience.company}</h4>
      <h6>{experience.position}</h6>
      <p>{experience.from} - {experience.to}</p>

      <p className='' style={{ marginTop: '15px' }}>{experience.description}</p>
      <p className='' style={{ marginBottom: '20px', fontWeight: "" }}>{experience.location}</p>

      {experience && (
        <button
          type="button"
          className='experience__view-btn'
          onClick={handleOpen}
          aria-label='View details'
        >
          <Visibility />
        </button>
      )}

      <div>
        {/* Dialog component */}
        <Dialog open={open} onClose={handleClose} variant="outlined" fullWidth maxWidth='md'>
          <DialogTitle>
            <h3 style={{ margin: 0, fontSize: '1.5rem', fontWeight: '600', color: 'var(--clr-fg-alt)', lineHeight: '1.2' }}>Experience Details</h3>
          </DialogTitle>
          <DialogContent>
            <div className="modal-header">
              {/* Company Icon */}
              <img
                src={experience.icon}
                className="modal-avatar"
                alt="Company Logo"
              />

              {/* Position, Company Name, and Date */}
              <div className="modal-info">
                <h3 className="modal-title">{experience.position}</h3>
                <h4 className="modal-subtitle">{experience.company}</h4>
                <p className="modal-dates">{experience.startDate} - {experience.endDate}</p>
              </div>
            </div>

            {/* Description */}
            <div className="modal-section">
              <h4 className="modal-section-title">About This Role</h4>
              <p className="modal-description">{experience.description}</p>
              <p className="modal-description" style={{ fontStyle: 'italic', color: 'var(--clr-fg)', opacity: 0.8 }}>
                📍 {experience.location}
              </p>
            </div>

            {/* Responsibilities */}
            <div className="modal-section">
              <h4 className="modal-section-title">Key Responsibilities</h4>
              <ul className="modal-list">
                {experience.responsibilities?.map((item) => (
                  <li key={uniqid()}>{item}</li>
                ))}
              </ul>
            </div>

            {/* Stack */}
            <div className="modal-section">
              <h4 className="modal-section-title">Technologies Used</h4>
              <div className="modal-stack">
                {experience.stack.map((stack) => (
                  <div key={uniqid()} className="modal-stack-item">
                    <StackIcon name={stack} className="icon-small" /> 
                    <span>{stack}</span>
                  </div>
                ))}
              </div>
            </div>
          </DialogContent>

          <DialogActions>
            <Button onClick={handleClose} color="primary">
              Close
            </Button>
          </DialogActions>
        </Dialog>
      </div>


    </div>
  )
}

export default ExperienceContainer